import React, {Component} from 'react';
import {Link} from "react-router-dom";
import FirstLevelItem from "../components/Sidebar/FirstLevelItem";
import {ACCESS_TOKEN, SERVLET_PATH, VirtualHost} from "../constants";
import {EntegratorIdentifiers, UserRightsEnum} from "../helper/enums";
import {
	showCustomerAnnouncement,
	showEarsivInbox, showETicaret, showKolaySmartMbt,
	showPredefinedBtn,
	showProgressPayment,
	showSidebarSgkFaturalar, showVatStateReport
} from "../helper/permission";
import {hasUserRight} from "../helper/helper";

class Sidebar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: "homePage",
			entegratorConf: this.props.entegratorConf,
			searchKey: "",
			clickedWithSearchKey: false,
			mainMenus: []
		};

		this.hasSidebarMenu = this.hasSidebarMenu.bind(this);
		this.onChangeSelected = this.onChangeSelected.bind(this);
		this.toggleSidebar = this.toggleSidebar.bind(this);
		this.onSelectReport = this.onSelectReport.bind(this);
		this.onClickLinked = this.onClickLinked.bind(this);
		this.hasContainsSearchKey = this.hasContainsSearchKey.bind(this);
		this.updateMenus = this.updateMenus.bind(this);
		this.scrollToMenuItem = this.scrollToMenuItem.bind(this);
	}

	componentDidMount() {
		this.updateMenus(this.state.mainMenus);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.clickedWithSearchKey) {
			if (prevState.mainMenus !== this.state.mainMenus) {
				this.updateMenus(this.state.mainMenus);
			}
			this.setState({clickedWithSearchKey: false});
			this.scrollToMenuItem(this.state.selected);
		}
	}

	updateMenus(mainMenus) {
		document.querySelectorAll('.sidebar .show').forEach(element => {
			element.classList.remove('show');
		});
		mainMenus.forEach(menuId => {
			const element = document.getElementById(menuId);
			if (element) {
				element.classList.add('show');
			}
		});
	}

	onChangeSelected(selected, event, arr = [], itemId) {
		const newMainMenus = [...arr, selected];
		if (this.state.searchKey !== '') {
			this.setState({clickedWithSearchKey: true, selected, searchKey: '', mainMenus: newMainMenus});
		} else {
			this.setState({selected, searchKey: '', mainMenus: newMainMenus});
		}

		this.props.reload(null, "sidebar");
		this.props.resetMasterSelected();
	}

	scrollToMenuItem(itemId) {
		const element = document.getElementById(itemId);
		if (element) {
			element.scrollIntoView({
				behavior: 'auto',
				block: 'center',
			});
		}
	}

	onClickLinked = () => {
		let url = this.state.entegratorConf.farmaUrl + "access-token?jwtToken=" + localStorage.getItem(ACCESS_TOKEN);
		window.open(url, "_blank");
	}

	onSelectReport(selected, event, type, arr = []) {
		if (this.state.searchKey !== '') {
			this.setState({clickedWithSearchKey: true, selected, searchKey: '', mainMenus: [...arr]});
		} else {
			this.setState({selected, searchKey: '', mainMenus: [...arr]});
		}
		this.props.reload(null, "sidebar");
		this.props.onSelectReport(type);
	}

	toggleSidebar() {
		if (this.props.canToggle) {
			document.body.classList.toggle('sidebar-mini');
			this.props.setOffsetWidth(document.getElementById('sidebarModeButton').children[0].offsetWidth);
		}
	}

	isCagriMerkeziImpersonate() {
		return this.props.impersonateUserRoleId === 3 && ["kolaysoft", "smart", "mbtfatura"].includes(VirtualHost.conf.resourcePrefix);
	}

	isBayiSorumlusuImpersonate() {
		return this.props.impersonateUserRoleId === 4 && ["kolaysoft", "smart", "mbtfatura"].includes(VirtualHost.conf.resourcePrefix);
	}

	isEFatura() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EFATURA;
	}

	isEGiderPusulasi() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EGIDERPUSULASI;
	}

	isEIrsaliye() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EIRSALIYE;
	}

	isEArsiv() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EARSIV;
	}

	isEMM() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EMM;
	}

	isESMM() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.ESMM;
	}

	isExchange() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EEXCHANGE;
	}

    isEczaciKart() {
	  return this.props.currentUser && VirtualHost.conf.resourcePrefix === "eczacikart";
    }

   isEDefter() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EDEFTER;
	}

	isEDefterSaklama() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EDEFTERSAKLAMA;
	}

	isEDefterIkincilKopya() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EDEFTERIKINCILKOPYA;
	}

	isDefterChecker() {
		return this.props.currentUser.holder.accounting && this.props.currentUser.holder.accounting.DEFTERCHECKER;
	}

	isEntegrator() {
		return this.props.currentUser && this.props.currentUser.entegrator;
	}

	isImpersonate() {
		return this.props.currentUser && this.props.currentUser.impersonate;
	}

	isAdminUser() {
		return this.props.currentUser && this.props.currentUser.adminUser;
	}

	isTakimLideriUser() {
		return this.props.currentUser && this.props.currentUser.roleId && this.props.currentUser.roleId === 4;
	}

	isDistributor() {
		return this.props.currentUser && this.props.currentUser.distributor;
	}

	isEBelge() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EARSIVBESBINOTUZBIN;
	}

	hasSidebarMenu(title) {
		return this.props.currentUser && (this.props.currentUser.sidebarMenus[title] === true);
	}

	isSuperAdmin(){
        return this.props.currentUser && this.props.currentUser.username==='111111444';
    }

	isEAdisyon() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EADISYON;
	}

	isESigorta() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.ESIGORTA;
	}

	isETicaret() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.ETICARET;
	}

	removeTurkishCharacters = (str) => {
		const turkishCharacters = {
			'ğ': 'g', 'Ğ': 'G',
			'ü': 'u', 'Ü': 'U',
			'ş': 's', 'Ş': 'S',
			'ı': 'i', 'İ': 'I',
			'ö': 'o', 'Ö': 'O',
			'ç': 'c', 'Ç': 'C',
			' ': '-'
		};

		return str.split('').map(char => turkishCharacters[char] || char).join('');
	};
	hasContainsSearchKey(value) {
		if (value === "not_submenu" && this.state.searchKey !== "") {
			return false;
		}
		let searchKey = this.removeTurkishCharacters(this.state.searchKey).toLowerCase();
		value = this.removeTurkishCharacters(value).toLowerCase();

		if (value.includes(searchKey)) {
			return true;
		}
		return false;
	};

	render() {
		const selected = this.props.masterSelected ? this.props.masterSelected : this.state.selected;
		const holder = this.props.currentUser.holder;
		const searchKeyExists = this.state.searchKey && this.state.searchKey.trim() !== "";
		return (
			<div className="sidebar" style={this.props.canToggle ? {} : {pointerEvents: 'none'}}>

				<div className="logo" id="sidebar">
					<a href="/" className="simple-text logo-mini">
						<img className="simple-text logo-mini"
							 src={SERVLET_PATH + "/api/virtual/resource/sidebarMini.png"}
							 style={{padding: '0px 0px 0px 0px'}}/>
					</a>
					<img className=" simple-text logo-normal"
						 src={SERVLET_PATH + "/api/virtual/resource/sidebar.png"}
					/>

					<div className="navbar-minimize ">
						<button id='sidebarModeButton' onClick={this.toggleSidebar} style={{marginTop: '10px'}}
								className=" btn btn-simple btn-icon btn-neutral btn-round">
							<i className="now-ui-icons text_align-center visible-on-sidebar-regular"/>
							<i className="now-ui-icons design_bullet-list-67 visible-on-sidebar-mini"/>
						</button>
					</div>

				</div>

				<div className="sidebar-wrapper scrollbar" id="style-7" style={this.props.decideVakifbankStyle()}>
					{this.props.currentUser && this.props.currentUser.roleId && this.props.currentUser.roleId !== 3 && this.props.currentUser.roleId !== 5 && this.props.currentUser.roleId !== 4 &&
					<ul className="nav">
						<li>
							<a href="#" className="search-bar" onClick={(e) => e.preventDefault()}
							   style={{
								   display: 'flex',
								   alignItems: 'center',
								   width: '100%',
								   textDecoration: 'none'
							   }}>
								<i className="fa fa-search fa-fw"  style={{ marginRight: '8px' }}/>
								<input type="text" value={this.state.searchKey} placeholder="Ara..."
									   onChange={(e) =>
										   this.setState({"searchKey": e.target.value})
									   }
									   style={{
										   flex: 1,
										   width: '90%',
										   border: 'none',
										   padding: '8px',
										   fontSize: '16px',
										   outline: 'none'
									   }}/>
							</a>
						</li>

						{this.hasContainsSearchKey("Ana Sayfa") &&
						<FirstLevelItem name="homePage" label="Ana Sayfa"
										isActive={selected === "homePage"}
										show={this.hasSidebarMenu("main_homePage")}
										icons="fa fa-home fa-fw" clicked={this.onChangeSelected}/>
						}

						{this.hasContainsSearchKey("Dijital Havan") && this.props.currentUser.username === "1" && [EntegratorIdentifiers.KOLAYSOFT].includes(this.state.entegratorConf.identifier) &&
							<FirstLevelItem name="homePage" label="Dijital Havan"
											isActive={selected === "farma"}
											className={"first-level-item-glow"}
											show={this.hasSidebarMenu("main_homePage")}
											icons="fa fa-home fa-fw" clicked={this.onClickLinked}/>
						}

						{this.hasContainsSearchKey("Bu Menüyü Düzenle") &&
						<FirstLevelItem name="customizeSidebar" label="Bu Menüyü Düzenle"
										isActive={selected === "customizeSidebar"}
										show={this.hasSidebarMenu("customizeSidebar")}
										icons="fa fa-flask fa-fw" clicked={this.onChangeSelected}/>
						}

						{this.hasSidebarMenu("main_settings") &&
						<li>
							{this.hasContainsSearchKey("not_submenu") &&
								<a data-toggle="collapse" href="#customerSettings">
									<i className="fa fa-gear fa-fw "/>
									<p>Ayarlar<b className="caret"/></p>
								</a>
							}
							<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="customerSettings">
								<ul className="nav">
									{(this.hasSidebarMenu("settings_prefixCode") && (this.isEArsiv() || this.isEFatura() || this.isEIrsaliye() || this.isEMM() || this.isESMM() || this.isEGiderPusulasi()))
										&& this.hasContainsSearchKey("Belge Ön Eki") &&
									<li className={selected === "prefixCode" ? 'active' : ''}
										id={"prefixCode"}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
										onClick={(e) => this.onChangeSelected("prefixCode", e,["customerSettings"])}>
										<Link to="/prefixCode" >
											<i className="fa fa-file-text"/>
											<span className="sidebar-normal"
												  style={{fontSize: "14px", fontWeight: "400"}}>Belge Ön Eki</span>
										</Link>
									</li>
									}
									{(this.isAdminUser() && (this.isEArsiv() || this.isEFatura())) && this.hasSidebarMenu("vkn_tckn_kisitlari")
										&& this.hasContainsSearchKey("VKN/TCKN Kısıtları") &&
									<li className={selected === "hiddenVknTcknList" ? 'active' : ''}
										id={"hiddenVknTcknList"}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
										onClick={(e) => this.onChangeSelected("hiddenVknTcknList", e, ["customerSettings"])}>
										<Link to="/hiddenVknTcknList">
											<i className="fa fa-file-text"/>
											<span className="sidebar-normal" style={{
												fontSize: "14px",
												fontWeight: "400"
											}}>VKN/TCKN Kısıtları</span>
										</Link>
									</li>
									}

									{this.hasSidebarMenu("settings_xsltYonetimi") && this.hasContainsSearchKey("XSLT Yönetimi") &&
									<li className={selected === "xsltYonetimi" ? 'active' : ''}
										id={"xsltYonetimi"}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
										onClick={(e) => this.onChangeSelected("xsltYonetimi", e,["customerSettings"])}>
										<Link to="/xsltYonetimi">
											<i className="fa fa-random" aria-hidden="true"/>
											<span className="sidebar-normal"
												  style={{fontSize: "14px", fontWeight: "400"}}> XSLT Yönetimi </span>
										</Link>
									</li>}
									{(this.hasSidebarMenu("settings_userList") && this.isAdminUser()) && this.hasContainsSearchKey("Kullanıcı İşlemleri") &&
									<li className={selected === "userList" ? 'active' : ''}
										id={"userList"}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
										onClick={(e) => this.onChangeSelected("userList", e,["customerSettings"])}>
										<Link to="/userList">
											<i className="fa fa-users" aria-hidden="true"/>
											<span className="sidebar-normal"
												  style={{fontSize: "14px", fontWeight: "400"}}> Kullanıcı İşlemleri </span>
										</Link>
									</li>}

									{(this.hasSidebarMenu("settings_companyProfile") && this.isAdminUser()) && this.hasContainsSearchKey("Firma Profili") &&
									<li className={selected === "companyProfile" ? 'active' : ''}
										id={"companyProfile"}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
										onClick={(e) => this.onChangeSelected("companyProfile", e,["customerSettings"])}>
										<Link to={"/companyProfile/" + this.props.currentUser.customerId}>
											<i className="fa fa-address-card" aria-hidden="true"/>
											<span className="sidebar-normal"
												  style={{fontSize: "14px", fontWeight: "400"}}> Firma Profili </span>
										</Link>
									</li>}

									{this.hasSidebarMenu("settings_inboxWarning") && this.hasContainsSearchKey("Fatura Uyarı Bilgileri") &&
									<li className={selected === "inboxWarning" ? 'active' : ''}
										id={"inboxWarning"}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
										onClick={(e) => this.onChangeSelected("inboxWarning", e,["customerSettings"])}>
										<Link to="/inboxWarning">
											<i className="fa fa-exclamation-circle" aria-hidden="true"/>
											<span className="sidebar-normal" style={{
												fontSize: "14px",
												fontWeight: "400"
											}}> Fatura Uyarı Bilgileri </span>
										</Link>
									</li>}

									{this.hasSidebarMenu("settings_signatureValidate") && this.hasContainsSearchKey("İmza Doğrulama") &&
									<li className={selected === "signatureValidate" ? 'active' : ''}
										id={"signatureValidate"}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
										onClick={(e) => this.onChangeSelected("signatureValidate", e,["customerSettings"])}>
										<Link to="/signature/validate">
											<i className="fa fa-exclamation-circle" aria-hidden="true"/>
											<span className="sidebar-normal"
												  style={{fontSize: "14px", fontWeight: "400"}}> İmza Doğrulama </span>
										</Link>
									</li>}
									{(this.isEMM() || this.isEFatura() || this.isEArsiv() || this.isEIrsaliye()) &&  this.hasSidebarMenu("marking") &&
										this.hasContainsSearchKey("İşaretler") &&
									<li className={selected === "tagList" ? 'active' : ''}
										id={"tagList"}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
										onClick={(e) => this.onChangeSelected("tagList", e,["customerSettings"])}>
										<Link to="/tagList">
											<i className="fa fa-flag"/>
											<span className="sidebar-normal"
												  style={{fontSize: "14px", fontWeight: "400"}}>İşaretler</span>
										</Link>
									</li>
									}
									{ (this.isAdminUser() &&
											((VirtualHost.conf.resourcePrefix === "kolaysoft" && (this.isCagriMerkeziImpersonate() || this.isBayiSorumlusuImpersonate()))
												|| showKolaySmartMbt(this.state.entegratorConf.identifier))) && this.hasSidebarMenu("settings_my_document_status_info")
										&& this.hasContainsSearchKey("Belge Durumu") &&
										<li className={selected === "myDocumentStatusInfo" ? 'active' : ''}
											id={"myDocumentStatusInfo"}
											style={{
												paddingLeft: searchKeyExists ? "0px" : "5px",
												marginBottom: searchKeyExists ? "5px" : ""
											}}
											onClick={(e) => this.onChangeSelected("myDocumentStatusInfo", e,["customerSettings"])}>
											<Link to="/myDocumentStatusInfo">
												<i className="fa fa-share"/>
												<span className="sidebar-normal"
													  style={{fontSize: "14px", fontWeight: "400"}}>
													Belge Durumu
													{searchKeyExists && <br />}
													{searchKeyExists ? " (Ayarlar)" : ""}
												</span>
											</Link>
										</li>
									}
									{(this.hasSidebarMenu("service_documentation") && this.hasContainsSearchKey("Servis Dokümantasyon") && VirtualHost.conf.webSiteUrl === 'http://portal.kolayentegrasyon.net')
										&& this.hasContainsSearchKey("Servis Dokümantasyon") &&
										<li className={selected === "serviceDoc" ? 'active' : ''}
											id={"serviceDoc"}
											onClick={(e) => this.onChangeSelected("serviceDoc", e,["manage"])}
											style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											<Link to="/serviceDocumentation">
												<i className="fa fa-server"/>
												<span className="sidebar-normal" style={{
													fontSize: "14px",
													fontWeight: "400"
												}}>Servis Dokümantasyon</span>
											</Link>
										</li>
									}
								</ul>
							</div>
						</li>
						}
						{this.hasContainsSearchKey("Ürün-Hizmet") &&
							<FirstLevelItem name="stockCard" label="Ürün-Hizmet"
											isActive={selected === "stockCard"}
											show={this.hasSidebarMenu("main_stockCard")}
											icons="fa fa-list fa-fw"
											clicked={this.onChangeSelected}/>
						}
						{this.hasContainsSearchKey("Cari") &&
							<FirstLevelItem name="externalCustomer" label="Cari"
											show={this.hasSidebarMenu("ednsm_cari")}
											isActive={selected === "externalCustomer"} icons="fa fa-adjust"
											clicked={() => this.onChangeSelected('externalCustomer')}/>
						}

						{(this.hasSidebarMenu("main_edonusum") && holder.portal) &&
						<li>
							{this.hasContainsSearchKey("not_submenu") &&
								<a data-toggle="collapse" href="#pagesTransformation">
									<i className="fa fa-recycle"/>
									<p>e-Dönüşüm<b className="caret"/></p>
								</a>
							}
							<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="pagesTransformation">
								{(this.isCagriMerkeziImpersonate() || this.isBayiSorumlusuImpersonate()) ?
									<ul className="nav">
										{this.hasContainsSearchKey("Belge Durumu") &&
											<li className={selected === "documentStatusInfo" ? 'active' : ''}
												id={"documentStatusInfo"}
												style={{
													paddingLeft: searchKeyExists ? "0px" : "5x",
													marginBottom: searchKeyExists ? "5px" : ""
												}}
												onClick={(e) => this.onChangeSelected("documentStatusInfo", e,["pagesTransformation"])}>
												<Link to="/documentStatusInfo">
													<i className="fa fa-share"/>
													<span className="sidebar-normal" style={{
														fontSize: "14px",
														fontWeight: "400"
													}}>
														Belge Durumu
														{searchKeyExists && <br/>}
														{searchKeyExists ? " (e-Dönüşüm)" : ""}
													</span>
												</Link>
											</li>
										}
									</ul> :
									<ul className="nav">
										{this.isEFatura() && this.isEArsiv() && this.isAdminUser() &&
											"neoyazilim" === VirtualHost.conf.resourcePrefix && "8590141934" === this.props.currentUser.vknTckn &&
											this.hasContainsSearchKey("Voyage Fatura Listesi") &&
											<li className={selected === "voyageDocumentList" ? 'active' : ''}
												id={"voyageDocumentList"}
												style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
												onClick={(e) => this.onChangeSelected("voyageDocumentList", e,["pagesTransformation"])}>
												<Link to="/voyageDocumentList">
													<i className="fas fa-dolly"/>
													<span className="sidebar-normal"
														  style={{fontSize: "14px", fontWeight: "400"}}>Voyage Fatura Listesi</span>
												</Link>
											</li>}

									{/*{this.isEFatura() && this.isEArsiv() && this.isAdminUser() && "cicekfatura" === VirtualHost.conf.resourcePrefix &&*/}
									{/*	<li className={selected === "orderList" ? 'active' : ''}*/}
									{/*		style={{"paddingLeft": "5px"}}*/}
									{/*		onClick={(e) => this.onChangeSelected("orderList", e)}>*/}
									{/*		<Link to="/orderList">*/}
									{/*			<i className="fas fa-dolly"/>*/}
									{/*			<span className="sidebar-normal">Siparişlerim</span>*/}
									{/*		</Link>*/}
									{/*	</li>}*/}

									{(this.hasSidebarMenu("ednsm_fat_invoiceTmp") && this.hasSidebarMenu("ednsm_ars_archiveInvoiceTmp")) && this.hasSidebarMenu("create_invoice") &&
										this.hasContainsSearchKey("Fatura Oluştur") &&
										<li className={selected === "invoiceCreate" ? 'active' : ''}
											id={"invoiceCreate"}
											style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
											onClick={(e) => this.onChangeSelected("invoiceCreate", e,["pagesTransformation"])}>
											<Link to={(showPredefinedBtn()) ?
												"/createEditInvoice/Tmp/0/EFATURA"
												:
												"/invoice/create"}>
												<i className="fa fa-arrow-circle-up"/>
												<span className="sidebar-normal" style={{
													fontSize: "14px",
													fontWeight: "400"
												}}>{"Fatura Oluştur"}</span>
											</Link>
										</li>
									}
									{(this.isEFatura() || this.isEIrsaliye()) && hasUserRight(UserRightsEnum.entegratorSettings.accessEnvelopeQuery, this.props.currentUser) &&
										(this.isEntegrator() || this.isDistributor()) &&
										this.hasSidebarMenu("ednsm_queryEnvelope") && this.hasContainsSearchKey("Zarf Sorgulama") &&
										<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											<a onClick={this.props.queryEnvelopeListener}>
												<i className="fa fa-search"/>
												<span className="sidebar-normal" style={{
													fontSize: "14px",
													fontWeight: "400"
												}}>{"Zarf Sorgulama"}</span>
											</a>
										</li>
									}

									{(this.props.currentUser && this.isEFatura() && showVatStateReport(this.state.entegratorConf.identifier,this.props.currentUser.parentCustomerId)) &&
										this.hasContainsSearchKey("KDV Durum Raporu") &&
										<li className={selected === "vatStateReport" ? 'active' : ''}
											id={"vatStateReport"}
											style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
											onClick={(e) => this.onChangeSelected("vatStateReport", e,["pagesTransformation"])}>
											<Link to="/vatStateReport">
												<i className="fa fa-files-o" aria-hidden="true"/>
												<span className="sidebar-normal"
													  style={{fontSize: "14px", fontWeight: "400"}}>KDV Durum Raporu</span>
											</Link>
										</li>
									}

									{(this.isAdminUser() &&
											((VirtualHost.conf.resourcePrefix === "kolaysoft" && (this.isCagriMerkeziImpersonate() || this.isBayiSorumlusuImpersonate()))
												|| showKolaySmartMbt(this.state.entegratorConf.identifier))) && this.hasContainsSearchKey("Belge Durumu") &&
										<li className={selected === "myDocumentStatusInfo" ? 'active' : ''}
											id={"myDocumentStatusInfo"}
											style={{
												paddingLeft: searchKeyExists ? "0px" : "5px",
												marginBottom: searchKeyExists ? "5px" : ""
											}}
											onClick={(e) => this.onChangeSelected("myDocumentStatusInfo", e,["pagesTransformation"])}>
											<Link to="/myDocumentStatusInfo">
												<i className="fa fa-share"/>
												<span className="sidebar-normal"
													  style={{fontSize: "14px", fontWeight: "400"}}>
													Belge Durumu
													{searchKeyExists && <br/>}
													{searchKeyExists ? " (e-Dönüşüm)" : ""}
												</span>
											</Link>
										</li>
									}

                                    {(this.hasSidebarMenu("ednsm_commerce") && this.isETicaret()) &&
                                        <li style={{paddingLeft: searchKeyExists ? "0px" : "5px"}}>
											{this.hasContainsSearchKey("not_submenu") &&
											<a data-toggle="collapse" href="#eCommerce">
                                                <i className="fas fa-dolly"/>
                                                <p className=""> E-Ticaret<b className="caret"/></p>
                                            </a>
											}
                                            <div className="collapse " id="eCommerce">
                                                <ul className="nav">
													{this.hasContainsSearchKey("Trendyol") &&
														<li className={selected === "trendyolPazaryeri" ? 'active' : ''}
															id={"trendyolPazaryeri"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("trendyolPazaryeri", e,["pagesTransformation","eCommerce"])}>
															<Link to="/trendyolPazaryeri">
																<i className="fa fa-arrow-circle-up"/>
																<span
																	className="sidebar-normal"
																	style={{
																		fontSize: "14px",
																		fontWeight: "400"
																	}}>Trendyol</span>
															</Link>
														</li>
													}
                                                    {/*<li className={selected === "ciceksepeti" ? 'active' : ''}*/}
                                                    {/*    style={{"paddingLeft": "5px"}}*/}
                                                    {/*    onClick={(e) => this.onChangeSelected("ciceksepeti", e)}>*/}
                                                    {/*    <Link to="/orderList">*/}
                                                    {/*        <i className="fa fa-arrow-circle-up"/>*/}
                                                    {/*        <span*/}
                                                    {/*            className="sidebar-normal">Çiçeksepeti</span>*/}
                                                    {/*    </Link>*/}
                                                    {/*</li>*/}
                                                    {/*<li className={selected === "hepsiburada" ? 'active' : ''}*/}
                                                    {/*    style={{"paddingLeft": "5px"}}*/}
                                                    {/*    onClick={(e) => this.onChangeSelected("hepsiburada", e)}>*/}
                                                    {/*    <Link to="/hepsiburada">*/}
                                                    {/*        <i className="fa fa-arrow-circle-up"/>*/}
                                                    {/*        <span*/}
                                                    {/*            className="sidebar-normal">Hepsiburada</span>*/}
                                                    {/*    </Link>*/}
                                                    {/*</li>*/}
                                                    {/*<li className={selected === "n11" ? 'active' : ''}*/}
                                                    {/*    style={{"paddingLeft": "5px"}}*/}
                                                    {/*    onClick={(e) => this.onChangeSelected("n11", e)}>*/}
                                                    {/*    <Link to="/n11">*/}
                                                    {/*        <i className="fa fa-arrow-circle-up"/>*/}
                                                    {/*        <span*/}
                                                    {/*            className="sidebar-normal">n11</span>*/}
                                                    {/*    </Link>*/}
                                                    {/*</li>*/}
                                                    {/*<li className={selected === "pazarama" ? 'active' : ''}*/}
                                                    {/*    style={{"paddingLeft": "5px"}}*/}
                                                    {/*    onClick={(e) => this.onChangeSelected("pazarama", e)}>*/}
                                                    {/*    <Link to="/pazarama">*/}
                                                    {/*        <i className="fa fa-arrow-circle-up"/>*/}
                                                    {/*        <span*/}
                                                    {/*            className="sidebar-normal">Pazarama</span>*/}
                                                    {/*    </Link>*/}
                                                    {/*</li>*/}
                                                    {/*<li className={selected === "ikas" ? 'active' : ''}*/}
                                                    {/*    style={{"paddingLeft": "5px"}}*/}
                                                    {/*    onClick={(e) => this.onChangeSelected("ikas", e)}>*/}
                                                    {/*    <Link to="/ikas">*/}
                                                    {/*        <i className="fa fa-arrow-circle-up"/>*/}
                                                    {/*        <span*/}
                                                    {/*            className="sidebar-normal">İkas</span>*/}
                                                    {/*    </Link>*/}
                                                    {/*</li>*/}
                                                </ul>
                                            </div>
                                        </li>
                                    }

									{(this.hasSidebarMenu("ednsm_irsaliye") && this.isEIrsaliye()) &&
										<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											{this.hasContainsSearchKey("not_submenu") &&
											<a data-toggle="collapse" href="#eDespatch">
												<i className="fa fa-file-text fa-fw"/>
												<p className=""> e-İrsaliye<b className="caret"/></p>
											</a>
											}
											<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="eDespatch">
												<ul className="nav">
													{this.hasSidebarMenu("ednsm_irs_despatch") && this.hasContainsSearchKey("Taslak İrsaliyeler") &&
														<li className={selected === "despatch" ? 'active' : ''}
															id={"despatch"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("despatch", e,["pagesTransformation","eDespatch"])}>
															<Link to="/despatch">
																<i className="fa fa-arrow-circle-up"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Taslak İrsaliyeler </span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_irs_eDespatchOutbox") && this.hasContainsSearchKey("Giden İrsaliyeler") &&
														<li className={selected === "eDespatchOutbox" ? 'active' : ''}
															id={"eDespatchOutbox"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("eDespatchOutbox", e,["pagesTransformation","eDespatch"])}>
															<Link to="/eDespatchOutbox">
																<i className="fa fa-share fa-fw"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Giden İrsaliyeler</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_irs_eDespatchInbox") && this.hasContainsSearchKey("Gelen İrsaliyeler") &&
														<li className={selected === "eDespatchInbox" ? 'active' : ''}
															id={"eDespatchInbox"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("eDespatchInbox", e,["pagesTransformation","eDespatch"])}>
															<Link to="/eDespatchInbox">
																<i className="fa fa-inbox"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Gelen İrsaliyeler</span>
															</Link>
														</li>
													}
													{ this.hasSidebarMenu("ednsm_irs_gibusers") && this.hasContainsSearchKey("GİB Kayıtlı Kullanıcılar") &&
														<li className={selected === "gibusersD" ? 'active' : ''}
															id={"gibusersD"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("gibusersD", e,["pagesTransformation","eDespatch"])}>
															<Link to="/gibusersD">
																<i className="fa fa-users" aria-hidden="true"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>GİB Kayıtlı Kullanıcılar{searchKeyExists ? " (e-İrsaliye)" : ""}</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_irs_eDespatchOutboxTransfer") && this.hasContainsSearchKey("Giden Transfer İrsaliyeler") &&
														<li className={selected === "eDespatchOutboxTransfer" ? 'active' : ''}
															id={"eDespatchOutboxTransfer"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("eDespatchOutboxTransfer", e,["pagesTransformation","eDespatch"])}>
															<Link to="/eDespatchOutboxTransfer">
																<i className="fa fa-share"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Giden Transfer İrsaliyeler</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_irs_eDespatchInboxTransfer") && this.hasContainsSearchKey("Gelen Transfer İrsaliyeler") &&
														<li className={selected === "eDespatchInboxTransfer" ? 'active' : ''}
															id={"eDespatchInboxTransfer"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("eDespatchInboxTransfer", e,["pagesTransformation","eDespatch"])}>
															<Link to="/eDespatchInboxTransfer">
																<i className="fa fa-reply"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Gelen Transfer İrsaliyeler</span>
															</Link>
														</li>
													}
												</ul>
											</div>
										</li>
									}
									{(this.hasSidebarMenu("ednsm_fatura") && this.isEFatura()) &&
										<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											{this.hasContainsSearchKey("not_submenu") &&
												<a data-toggle="collapse" href="#eInvoice">
													<i className="fa fa-newspaper-o"/>
													<p className=""> e-Fatura<b className="caret"/></p>
												</a>
											}
											<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="eInvoice">
												<ul className="nav">
													{this.hasSidebarMenu("ednsm_fat_invoiceTmp") && this.hasContainsSearchKey("Taslak Faturalar") &&
														<li className={selected === "invoiceTmp" ? 'active' : ''}
															id={"invoiceTmp"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("invoiceTmp", e,["pagesTransformation","eInvoice"])}>
															<Link to="/invoiceTmp">
																<i className="fa fa-arrow-circle-up"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}> Taslak Faturalar </span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_fat_eInvoiceOutbox") && this.hasContainsSearchKey("Giden Faturalar") &&
														<li className={selected === "eInvoiceOutbox" ? 'active' : ''}
															id={"eInvoiceOutbox"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("eInvoiceOutbox", e,["pagesTransformation","eInvoice"])}>
															<Link to="/eInvoiceOutbox">
																<i className="fa fa-share fa-fw"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Giden Faturalar</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_fat_eInvoiceInbox") && this.hasContainsSearchKey("Gelen Faturalar") &&
														<li className={selected === "eInvoiceInbox" ? 'active' : ''}
															id={"eInvoiceInbox"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("eInvoiceInbox", e,["pagesTransformation","eInvoice"])}>
															<Link to="/eInvoiceInbox">
																<i className="fa fa-inbox"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Gelen Faturalar</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_fat_gibusers") && this.hasContainsSearchKey("GİB Kayıtlı Kullanıcılar") &&
														<li className={selected === "gibusersI" ? 'active' : ''}
															id={"gibusersI"}
															style={{
																paddingLeft: searchKeyExists ? "0px" : "5px",
																marginBottom: searchKeyExists ? "5px" : ""
															}}
															onClick={(e) => this.onChangeSelected("gibusersI", e,["pagesTransformation","eInvoice"])}>
															<Link to="/gibusersI">
																<i className="fa fa-users" aria-hidden="true"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>
																	GİB Kayıtlı Kullanıcılar
																	{searchKeyExists && <br/>}
																	{searchKeyExists ? " (e-Fatura)" : ""}
																</span>
															</Link>
														</li>
													}
													{/*this.hasSidebarMenu("ednsm_fat_sgkXmlYukleme") && showSidebarSgkFaturalar() &&
												<li className={selected === "sgkXmlYukleme" ? 'active' : ''}
													style={{"paddingLeft": "5px"}}
													onClick={(e) => this.onChangeSelected("sgkXmlYukleme", e)}>
													<Link to="/sgkXmlYukleme">
														<i className="fa fa-plus"></i>
														<span className="sidebar-normal">Hastane Fatura Yükle</span>
													</Link>
												</li>
												*/}
													{this.hasSidebarMenu("ednsm_fat_sgkFaturalar") && this.hasSidebarMenu("ednsm_fat_hospitalInvoice") && showSidebarSgkFaturalar()
														&& this.hasContainsSearchKey("Hastane Fatura") &&
														<li className={selected === "sgkFaturalar" ? 'active' : ''}
															id={"sgkFaturalar"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("sgkFaturalar", e,["pagesTransformation","eInvoice"])}>
															<Link to="/sgkFaturalar">
																<i className="fa fa-hospital-o" aria-hidden="true"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Hastane Fatura</span>
															</Link>
														</li>
													}
													{"eczacikart" === VirtualHost.conf.resourcePrefix && this.hasContainsSearchKey("Depo İade Faturalar") &&
														<li className={selected === "depoIadeList" ? 'active' : ''}
															id={"depoIadeList"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("depoIadeList", e,["pagesTransformation","eInvoice"])}>
															<Link to="/depoIadeList">
																<i className=" fas fa-file-invoice"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}> Depo İade Faturalar </span>
															</Link>
														</li>}
													{this.hasSidebarMenu("ednsm_fat_eInvoiceOutboxTransfer") && this.hasContainsSearchKey("Giden Transfer Faturalar") &&
														<li className={selected === "eInvoiceOutboxTransfer" ? 'active' : ''}
															id={"eInvoiceOutboxTransfer"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("eInvoiceOutboxTransfer", e,["pagesTransformation","eInvoice"])}>
															<Link to="/eInvoiceOutboxTransfer">
																<i className="fa fa-share"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Giden Transfer Faturalar</span>
															</Link>
														</li>
													}

													{this.hasSidebarMenu("ednsm_fat_eInvoiceInboxTransfer") && this.hasContainsSearchKey("Gelen Transfer Faturalar") &&
														<li className={selected === "eInvoiceInboxTransfer" ? 'active' : ''}
															id={"eInvoiceInboxTransfer"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("eInvoiceInboxTransfer", e,["pagesTransformation","eInvoice"])}>
															<Link to="/eInvoiceInboxTransfer">
																<i className="fa fa-reply"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Gelen Transfer Faturalar</span>
															</Link>
														</li>
													}
												</ul>
											</div>
										</li>
									}
									{(this.hasSidebarMenu("ednsm_arsiv") && this.isEArsiv()) &&
										<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											{this.hasContainsSearchKey("not_submenu") &&
												<a data-toggle="collapse" href="#eArchiveInvoice">
													<i className="fa fa-archive"/>
													<p className=""> e-Arşiv<b className="caret"/></p>
												</a>
											}
											<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="eArchiveInvoice">
												<ul className="nav">
													{this.hasSidebarMenu("ednsm_ars_archiveInvoiceTmp") && this.hasContainsSearchKey("Taslak Arşiv Faturalar") &&
														<li className={selected === "archiveInvoiceTmp" ? 'active' : ''}
															id={"archiveInvoiceTmp"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("archiveInvoiceTmp", e,["pagesTransformation","eArchiveInvoice"])}>
															<Link to="/archiveInvoiceTmp">
																<i className="fa fa-arrow-circle-up"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}> Taslak Arşiv Faturalar </span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_ars_eAInvoice") && this.hasContainsSearchKey("e-Arşiv Faturalar") &&
														<li className={selected === "eAInvoice" ? 'active' : ''}
															id={"eAInvoice"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("eAInvoice", e,["pagesTransformation","eArchiveInvoice"])}>
															<Link to="/eAInvoice">
																<i className="fa fa-archive"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>e-Arşiv Faturalar</span>
															</Link>
														</li>
													}
													{(this.hasSidebarMenu("ednsm_ars_eAInvoice") && showEarsivInbox(this.state.entegratorConf.identifier)) && this.hasSidebarMenu("ednsm_ars_eAInvoiceInbox")
														&& this.hasContainsSearchKey("Gelen e-Arşiv Faturalar") &&
														<li className={selected === "belgeIn" ? 'active' : ''}
															id={"belgeIn"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("belgeIn", e,["pagesTransformation","eArchiveInvoice"])}>
															<Link to="/belgeIn">
																<i className="fa fa-inbox"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Gelen e-Arşiv Faturalar</span>
															</Link>
														</li>}
													{this.hasSidebarMenu("ednsm_ars_eAInvoiceTransfer") && this.hasContainsSearchKey("e-Arşiv Transfer Faturalar") &&
														<li className={selected === "eAInvoiceTransfer" ? 'active' : ''}
															id={"eAInvoiceTransfer"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("eAInvoiceTransfer", e,["pagesTransformation","eArchiveInvoice"])}>
															<Link to="/eAInvoiceTransfer">
																<i className="fa fa-reply"/>
																<span
																	className="sidebar-normal"
																	style={{fontSize: "14px", fontWeight: "400"}}>e-Arşiv Transfer Faturalar</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_ars_eArchiveReportRequest") && this.hasContainsSearchKey("Rapor Gönderme Talebi") &&
														<li className={selected === "eArchiveReportRequest" ? 'active' : ''}
															id={"eArchiveReportRequest"}
															style={{
																paddingLeft: searchKeyExists ? "0px" : "5px",
																marginBottom: searchKeyExists ? "5px" : ""
															}}
															onClick={(e) => this.onChangeSelected("eArchiveReportRequest", e,["pagesTransformation","eArchiveInvoice"])}>
															<Link to="/eArchiveReportRequest/archive">
																<i className="fa fa-send"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>
																	Rapor Gönderme Talebi
																	{searchKeyExists && <br/>}
																	{searchKeyExists ? " (e-Arşiv)" : ""}
																</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_ars_sentReportsList") && this.hasContainsSearchKey("Gönderilmiş Raporlar") &&
														<li className={selected === "eArchiveSentReportsList" ? 'active' : ''}
															id={"eArchiveSentReportsList"}
															style={{
																paddingLeft: searchKeyExists ? "0px" : "5px",
																marginBottom: searchKeyExists ? "5px" : ""
															}}
															onClick={(e) => this.onSelectReport("eArchiveSentReportsList", e, "eArchive",["pagesTransformation","eArchiveInvoice"])}>
															<Link to="/sentReportsList/archive">
																<i className="fa fa-area-chart"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>
																	 Gönderilmiş Raporlar
																	{searchKeyExists && <br />}
																	{searchKeyExists ? " (e-Arşiv)" : ""}
																</span>
															</Link>
														</li>
													}
													{false && this.hasSidebarMenu("ednsm_ars_mReportList") &&
														<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
															{this.hasContainsSearchKey("not_submenu") &&
																<a data-toggle="collapse" href="#okcReport">
																	<i className="fa fa-archive"/>
																	<p className="">ÖKC Mali Raporları<b
																		className="caret"/></p>
																</a>
															}
															<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="okcReport">
																<ul className="nav">
																	{this.hasSidebarMenu("ednsm_ars_archiveInvoiceTmp") && this.hasContainsSearchKey("Taslak Raporlar") &&
																		<li className={selected === "okcReportList" ? 'active' : ''}
																			id={"okcReportList"}
																			style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
																			onClick={(e) => this.onChangeSelected("okcReportList", e,["pagesTransformation","eArchiveInvoice","okcReport"])}>
																			<Link to="/okcReportList">
																				<i className="fa fa-arrow-circle-up"/>
																				<span
																					className="sidebar-normal" style={{
																					fontSize: "14px",
																					fontWeight: "400"
																				}}>Taslak Raporlar</span>
																			</Link>
																		</li>
																	}
																	{this.hasSidebarMenu("ednsm_ars_archiveInvoiceTmp") && this.hasContainsSearchKey("Giden Raporlar") &&
																		<li className={selected === "okcReports" ? 'active' : ''}
																			id={"okcReports"}
																			style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
																			onClick={(e) => this.onChangeSelected("okcReports", e,["pagesTransformation","eArchiveInvoice","okcReport"])}>
																			<Link to="/okcReports">
																				<i className="fa fa-share fa-fw"/>
																				<span
																					className="sidebar-normal" style={{
																					fontSize: "14px",
																					fontWeight: "400"
																				}}>Giden Raporlar</span>
																			</Link>
																		</li>
																	}
																</ul>
															</div>
														</li>
													}
													{this.hasSidebarMenu("ednsm_ars_expenseNoteList") && this.hasContainsSearchKey("Gider Pusulaları") &&
														<li className={selected === "expenseNoteList" ? 'active' : ''}
															id={"expenseNoteList"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("expenseNoteList", e,["pagesTransformation","eArchiveInvoice"])}>
															<Link to="/expenseNoteList">
																<i className="fa fa-share-square"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Gider Pusulaları</span>
															</Link>
														</li>
													}
												</ul>
											</div>
										</li>
									}
									{(this.hasSidebarMenu("ednsm_mustahsil") && this.isEMM()) &&
										<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											{this.hasContainsSearchKey("not_submenu") &&
												<a data-toggle="collapse" href="#eArchiveVoucherMM">
													<i className="fa fa-microchip"/>
													<p className=""> e-Müstahsil<b className="caret"/></p>
												</a>
											}
											<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="eArchiveVoucherMM">
												<ul className="nav">
													{this.hasSidebarMenu("ednsm_mm_eVoucherMT") && this.hasContainsSearchKey("Taslak Makbuzlar") &&
														<li className={selected === "eVoucherMT" ? 'active' : ''}
															id={"eVoucherMT"}
															style={{
																paddingLeft: searchKeyExists ? "0px" : "5px",
																marginBottom: searchKeyExists ? "5px" : ""
															}}
															onClick={(e) => this.onChangeSelected("eVoucherMT", e,["pagesTransformation","eArchiveVoucherMM"])}>
															<Link to="/eVoucherMT">
																<i className="fa fa-arrow-circle-up"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>
																	Taslak Makbuzlar
																	{searchKeyExists && <br/>}
																	{searchKeyExists ? " (e-Müstahsil)" : ""}</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_mm_eVoucherM") && this.hasContainsSearchKey("e-Müstahsil Makbuzlar") &&
														<li className={selected === "eVoucherM" ? 'active' : ''}
															id={"eVoucherM"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("eVoucherM", e,["pagesTransformation","eArchiveVoucherMM"])}>
															<Link to="/eVoucherM">
																<i className="fa fa-list-alt"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}> e-Müstahsil Makbuzlar</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_mm_eVoucherTransfer") && this.hasContainsSearchKey("Transfer Makbuzlar") &&
														<li className={selected === "eVoucherMTransfer" ? 'active' : ''}
															id={"eVoucherMTransfer"}
															style={{
																paddingLeft: searchKeyExists ? "0px" : "5px",
																marginBottom: searchKeyExists ? "5px" : ""
															}}
															onClick={(e) => this.onChangeSelected("eVoucherMTransfer", e,["pagesTransformation","eArchiveVoucherMM"])}>
															<Link to="/eVoucherMTransfer">
																<i className="fa fa-reply"/>
																<span
																	className="sidebar-normal"
																	style={{fontSize: "14px", fontWeight: "400"}}>
																	Transfer Makbuzlar
																	{searchKeyExists && <br/>}
																	{searchKeyExists ? " (e-Müstahsil)" : ""}
																</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_mm_eArchiveReportRequest") && this.hasContainsSearchKey("Rapor Gönderme Talebi") &&
														<li className={selected === "eMMReportRequest" ? 'active' : ''}
															id={"eMMReportRequest"}
															style={{
																paddingLeft: searchKeyExists ? "0px" : "5px",
																marginBottom: searchKeyExists ? "5px" : ""
															}}
															onClick={(e) => this.onChangeSelected("eMMReportRequest", e,["pagesTransformation","eArchiveVoucherMM"])}>
															<Link to="/eArchiveReportRequest/voucher">
																<i className="fa fa-send"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>
																	Rapor Gönderme Talebi
																	{searchKeyExists && <br />}
																	{searchKeyExists ? " (e-Müstahsil)" : ""}
																</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_mm_sentReportsList") && this.hasContainsSearchKey("Gönderilmiş Raporlar") &&
														<li className={selected === "eMMSentReportsList" ? 'active' : ''}
															id={"eMMSentReportsList"}
															style={{
																paddingLeft: searchKeyExists ? "0px" : "5px",
																marginBottom: searchKeyExists ? "5px" : ""
															}}
															onClick={(e) => this.onSelectReport("eMMSentReportsList", e, "eArchive",["pagesTransformation","eArchiveVoucherMM"])}>
															<Link to="/sentReportsList/voucher">
																<i className="fa fa-area-chart"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>
																	Gönderilmiş Raporlar
																	{searchKeyExists && <br />}
																	{searchKeyExists ? " (e-Müstahsil)" : ""}
																</span>
															</Link>
														</li>
													}
												</ul>
											</div>
										</li>
									}
									{(this.hasSidebarMenu("ednsm_serbestmeslek") && this.isESMM()) &&
										<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											{this.hasContainsSearchKey("not_submenu") &&
												<a data-toggle="collapse" href="#eArchiveVoucherSMM">
													<i className="fa fa-clipboard" aria-hidden="true"/>
													<span className="sidebar-normal"> e-Serbest Meslek<b
														className="caret"/></span>
												</a>
											}
											<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="eArchiveVoucherSMM">
												<ul className="nav">
													{this.hasSidebarMenu("ednsm_smm_eVoucherST") && this.hasContainsSearchKey("Taslak Makbuzlar") &&
														<li className={selected === "eVoucherST" ? 'active' : ''}
															id={"eVoucherST"}
															style={{
																paddingLeft: searchKeyExists ? "0px" : "5px",
																marginBottom: searchKeyExists ? "5px" : ""
															}}
															onClick={(e) => this.onChangeSelected("eVoucherST", e,["pagesTransformation","eArchiveVoucherSMM"])}>
															<Link to="/eVoucherST">
																<i className="fa fa-arrow-circle-up"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>
																	Taslak Makbuzlar
																	{searchKeyExists && <br/>}
																	{searchKeyExists ? " (e-Serbest Meslek)" : ""}
																</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_smm_eVoucherS") && this.hasContainsSearchKey("e-Serbest Meslek Makbuzlar") &&
														<li className={selected === "eVoucherS" ? 'active' : ''}
															id={"eVoucherS"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("eVoucherS", e,["pagesTransformation","eArchiveVoucherSMM"])}>
															<Link to="/eVoucherS">
																<i className="fa fa-clipboard"/>
																<span
																	style={{letterSpacing: '0.4px'}}
																	className="sidebar-normal"
																	style={{fontSize: "14px", fontWeight: "400"}}> e-Serbest Meslek Makbuzlar</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_smm_eVoucherTransfer") && this.hasContainsSearchKey("Transfer Makbuzlar") &&
														<li className={selected === "eVoucherSTransfer" ? 'active' : ''}
															id={"eVoucherSTransfer"}
															style={{
																paddingLeft: searchKeyExists ? "0px" : "5px",
																marginBottom: searchKeyExists ? "5px" : ""
															}}
															onClick={(e) => this.onChangeSelected("eVoucherSTransfer", e,["pagesTransformation","eArchiveVoucherSMM"])}>
															<Link to="/eVoucherSTransfer">
																<i className="fa fa-reply"/>
																<span
																	className="sidebar-normal"
																	style={{fontSize: "14px", fontWeight: "400"}}>
																	Transfer Makbuzlar
																	{searchKeyExists && <br/>}
																	{searchKeyExists ? " (e-Serbest Meslek)" : ""}
																</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_smm_eArchiveReportRequest") && this.hasContainsSearchKey("Rapor Gönderme Talebi") &&
														<li className={selected === "eSMMReportRequest" ? 'active' : ''}
															id={"eSMMReportRequest"}
															style={{
																paddingLeft: searchKeyExists ? "0px" : "5px",
																marginBottom: searchKeyExists ? "5px" : ""
															}}
															onClick={(e) => this.onChangeSelected("eSMMReportRequest", e,["pagesTransformation","eArchiveVoucherSMM"])}>
															<Link to="/eArchiveReportRequest/voucher">
																<i className="fa fa-send"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>
																	Rapor Gönderme Talebi
																	{searchKeyExists && <br/>}
																	{searchKeyExists ? " (e-Serbest Meslek)" : ""}
																</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_smm_sentReportsList") && this.hasContainsSearchKey("Gönderilmiş Raporlar") &&
														<li className={selected === "eSMMSentReportsList" ? 'active' : ''}
															id={"eSMMSentReportsList"}
															style={{
																paddingLeft: searchKeyExists ? "0px" : "5px",
																marginBottom: searchKeyExists ? "5px" : ""
															}}
															onClick={(e) => this.onSelectReport("eSMMSentReportsList", e, "serbestMeslek",["pagesTransformation","eArchiveVoucherSMM"])}>
															<Link to="/sentReportsList/voucher">
																<i className="fa fa-area-chart"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>
																	Gönderilmiş Raporlar
																	{searchKeyExists && <br />}
																	{searchKeyExists ? " (e-Serbest Meslek)" : ""}
																</span>
															</Link>
														</li>
													}
												</ul>
											</div>
										</li>
									}
									{(this.hasSidebarMenu("ednsm_defter") && this.isEDefter()) &&
										<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											{this.hasContainsSearchKey("not_submenu") &&
												<a data-toggle="collapse" href="#edefter">
													<i className="fa fa-book" aria-hidden="true"/>
													<span className="sidebar-normal"> E-Defter<b
														className="caret"/></span>
												</a>
											}
											<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="edefter">
												<ul className="nav">
													{this.hasSidebarMenu("ednsm_def_edefterCreate") && this.hasContainsSearchKey("E-Defter Oluştur") &&
														<li className={selected === "edefterCreate" ? 'active' : ''}
															id={"edefterCreate"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("edefterCreate", e,["pagesTransformation","edefter"])}>
															<Link to="/edefter/create">
																<i className="fa fa-upload"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>E-Defter Oluştur</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_def_edefterList") && this.hasContainsSearchKey("Oluşturulan E-Defterler") &&
														<li className={selected === "edefterList" ? 'active' : ''}
															id={"edefterList"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("edefterList", e,["pagesTransformation","edefter"])}>
															<Link to="/edefter/list">
																<i className="fa fa-list"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Oluşturulan E-Defterler</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_def_edefterCustomerDefterInformation") && this.hasContainsSearchKey("E-Defter Bilgileri") &&
														<li className={selected === "edefterCustomerDefterInformation" ? 'active' : ''}
															id={"edefterCustomerDefterInformation"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("edefterCustomerDefterInformation", e,["pagesTransformation","edefter"])}>
															<Link to="/edefter/eDefterInformation">
																<i className="fa fa-align-left"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>E-Defter Bilgileri</span>
															</Link>
														</li>
													}
												</ul>
											</div>
										</li>
									}
									{(this.hasSidebarMenu("ednsm_deftersaklama") && this.isEDefterSaklama()) &&
										<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											{this.hasContainsSearchKey("not_submenu") &&
												<a data-toggle="collapse" href="#edefterStorage">

													<i className="fa fa-book" aria-hidden="true"/>
													<span className="sidebar-normal"> E-Defter Saklama
												<b className="caret"/></span>
												</a>
											}
											<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="edefterStorage">
												<ul className="nav">
													{this.hasSidebarMenu("ednsm_defsak_uploadDefter") && this.hasContainsSearchKey("E-Defter Zip Yükleme") &&
														<li className={selected === "uploadDefter" ? 'active' : ''}
															id={"uploadDefter"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("uploadDefter", e,["pagesTransformation","edefterStorage"])}>
															<Link to="/edefterZipYukleme">
																<i className="fa fa-file-archive"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>E-Defter Zip Yükleme</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_defsak_uploadedDefter") && this.hasContainsSearchKey("Yüklenen Defterler") &&
														<li className={selected === "uploadedDefter" ? 'active' : ''}
															id={"uploadedDefter"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("uploadedDefter", e,["pagesTransformation","edefterStorage"])}>
															<Link to="/yuklenenDefterler">
																<i className="fa fa-list"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Yüklenen Defterler</span>
															</Link>
														</li>
													}
												</ul>
											</div>
										</li>
									}
									{this.isEDefterIkincilKopya() && this.hasSidebarMenu("ednsm_def_edefterSecondaryCopy") && this.hasContainsSearchKey("E-Defter İkincil Kopya") &&
										<li className={selected === "secondaryCopyTransfer" ? 'active' : ''}
											id={"secondaryCopyTransfer"}
											style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
											onClick={(e) => this.onChangeSelected("secondaryCopyTransfer", e,["pagesTransformation"])}>
											<Link to="/secondaryCopyTransfer">
												<i className="fa fa-book"/>
												<span className="sidebar-normal"
													  style={{fontSize: "14px", fontWeight: "400"}}>E-Defter İkincil Kopya</span>
											</Link>
										</li>
									}
									{this.isEGiderPusulasi() && this.hasSidebarMenu("ednsm_egider") &&
										<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											{this.hasContainsSearchKey("not_submenu") &&
												<a data-toggle="collapse" href="#eexpenseNote">
													<i className="fa fa-calculator" aria-hidden="true"/>
													<span className="sidebar-normal"
														  style={{fontSize: "14px", fontWeight: "400"}}> e-Gider Pusulası
												<b className="caret"/></span>
												</a>
											}
											<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="eexpenseNote">
												<ul className="nav">
													{this.hasSidebarMenu("ednsm_egdr_eGiderPusulalar") && this.hasContainsSearchKey("E-Gider Pusulalar") &&
													<li className={selected === "newExpenseNote" ? 'active' : ''}
														id={"eExpenseNotes"}
														style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
														onClick={(e) => this.onChangeSelected("eExpenseNotes", e,["pagesTransformation","eexpenseNote"])}>
														<Link to="/newExpenseNote">
															<i className="fa fa-list"/>
															<span className="sidebar-normal"
																  style={{fontSize: "14px", fontWeight: "400"}}>E-Gider Pusulalar</span>
														</Link>
													</li>
													}
												</ul>
											</div>
										</li>
									}
									{this.isExchange() && this.hasSidebarMenu("ednsm_edoviz") &&
										<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											{this.hasContainsSearchKey("not_submenu") &&
												<a data-toggle="collapse" href="#eArchiveVoucherEX">
													<i className="fa fa-eur" aria-hidden="true"/>
													<span className="sidebar-normal"> e-Döviz<b
														className="caret"/></span>
												</a>
											}
											<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="eArchiveVoucherEX">
												<ul className="nav">
													{this.hasSidebarMenu("ednsm_edoviz_taslakdoviz") && this.hasContainsSearchKey("Taslak Dövizler") &&
														<li className={selected === "eVoucherET" ? 'active' : ''}
															id={"eVoucherET"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("eVoucherET", e,["pagesTransformation","eArchiveVoucherEX"])}>
															<Link to="/eVoucherET">
																<i className="fa fa-arrow-circle-up"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}> Taslak Dövizler</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_edoviz_makbuzlar") && this.hasContainsSearchKey("e-Döviz Makbuzlar") &&
														<li className={selected === "exchangeList" ? 'active' : ''}
															id={"exchangeList"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("exchangeList", e,["pagesTransformation","eArchiveVoucherEX"])}>
															<Link to="/exchangeList">
																<i className="fa fa-clipboard"/>
																<span
																	className="sidebar-normal"
																	style={{fontSize: "14px", fontWeight: "400"}}> e-Döviz Makbuzlar</span>
															</Link>
														</li>
													}

												</ul>
											</div>
										</li>
									}
									{this.isEBelge() && this.hasSidebarMenu("ednsm_belge") &&
										<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											{this.hasContainsSearchKey("not_submenu") &&
												<a data-toggle="collapse" href="#ebelge">
													<i className="fas fa-newspaper-o" aria-hidden="true"/>
													<span className="sidebar-normal"> e-Belge
												<b className="caret"/></span>
												</a>
											}
											<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="ebelge">
												<ul className="nav">
													{this.hasSidebarMenu("ednsm_bel_documentT") && this.hasContainsSearchKey("Taslak Belgeler") &&
														<li className={selected === "belgeTmp" ? 'active' : ''}
															id={"belgeTmp"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("belgeTmp", e,["pagesTransformation","ebelge"])}>
															<Link to="/belgeTmp">
																<i className="fa fa-arrow-circle-up"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Taslak Belgeler</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_bel_documentOutbox") && this.hasContainsSearchKey("Giden Belgeler") &&
														<li className={selected === "belgeSend" ? 'active' : ''}
															id={"belgeSend"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("belgeSend", e,["pagesTransformation","ebelge"])}>
															<Link to="/belgeSend">
																<i className="fa fa-share fa-fw"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Giden Belgeler</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_bel_documentInbox") && this.hasContainsSearchKey("Gelen Belgeler") &&
														<li className={selected === "belgeIn" ? 'active' : ''}
															id={"belgeIn"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("belgeIn", e,["pagesTransformation","ebelge"])}>
															<Link to="/belgeIn">
																<i className="fa fa-inbox"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Gelen Belgeler</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_bel_documentBaBs") && this.hasContainsSearchKey("Sanal Ba/Bs") &&
														<li className={selected === "BaBs" ? 'active' : ''}
															id={"BaBs"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("BaBs", e,["pagesTransformation","ebelge"])}>
															<Link to="/BaBs">
																<i className="fa fa-list"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Sanal Ba/Bs</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_bel_documentRequest") && this.hasContainsSearchKey("İptal / İtiraz Talepleri") &&
														<li className={selected === "COBelge" ? 'active' : ''}
															id={"COBelge"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("COBelge", e,["pagesTransformation","ebelge"])}>
															<Link to="/COBelge">
																<i className="fas fa-ban"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>İptal / İtiraz Talepleri</span>
															</Link>
														</li>
													}
												</ul>
											</div>
										</li>
									}
									{this.isEAdisyon() && this.hasSidebarMenu("ednsm_adisyon") &&
										<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											{this.hasContainsSearchKey("not_submenu") &&
												<a data-toggle="collapse" href="#receipt">
													<i className="fa fa-calendar" aria-hidden="true"/>
													<span className="sidebar-normal"> e-Adisyon
												<b className="caret"/></span>
												</a>
											}
											<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="receipt">
												<ul className="nav">
													{this.hasSidebarMenu("ednsm_adsyn_list") && this.hasContainsSearchKey("E-Adisyon Listesi") &&
														<li className={selected === "receipt" ? 'active' : ''}
															id={"receiptList"}
															style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															onClick={(e) => this.onChangeSelected("receiptList", e,["pagesTransformation","receipt"])}>
															<Link to="/receiptList">
																<i className="fa fa-list"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>E-Adisyon Listesi</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_adsyn_sendingReport") && this.hasContainsSearchKey("Gönderilmiş Raporlar") &&
														<li className={selected === "receiptSentReportsList" ? 'active' : ''}
															id={"receiptSentReportsList"}
															style={{
																paddingLeft: searchKeyExists ? "0px" : "5px",
																marginBottom: searchKeyExists ? "5px" : ""
															}}
															onClick={(e) => this.onSelectReport("receiptSentReportsList", e, "receipt",["pagesTransformation","receipt"])}>
															<Link to="/sentReportsList/receipt">
																<i className="fa fa-area-chart"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>
																	Gönderilmiş Raporlar
																	{searchKeyExists && <br />}
																	{searchKeyExists ? " (e-Adisyon)" : ""}
																</span>
															</Link>
														</li>
													}
												</ul>
											</div>
										</li>
									}
									{this.isESigorta() && this.hasSidebarMenu("ednsm_sigorta") &&
											<li style={{paddingLeft: searchKeyExists ? "0px" : "5px"}}>
												{this.hasContainsSearchKey("not_submenu") &&
													<a data-toggle="collapse" href="#sigorta">
														<i className="fa fa-calendar" aria-hidden="true"/>
														<span className="sidebar-normal"> e-Sigorta
												<b className="caret"/></span>
													</a>
												}
												<div className={`collapse ${searchKeyExists ? 'show' : ''}`}
													 id="sigorta">
													<ul className="nav">
														{this.hasSidebarMenu("ednsm_sigorta_taslak") && this.hasContainsSearchKey("Taslak Sigortalar") &&
															<li className={selected === "sigortaTmp" ? 'active' : ''}
																id={"sigortaTmp"}
																style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
																onClick={(e) => this.onChangeSelected("sigortaTmp", e,["pagesTransformation","sigorta"])}>
																<Link to="/sigortaTmp">
																	<i className="fa fa-arrow-circle-up"/>
																	<span className="sidebar-normal"
																		  style={{fontSize: "14px", fontWeight: "400"}}>Taslak Sigortalar</span>
																</Link>
															</li>
														}
														{this.hasSidebarMenu("ednsm_sigorta_list") && this.hasContainsSearchKey("E-Sigorta Listesi") &&
															<li className={selected === "sigorta" ? 'active' : ''}
																id={"sigortaList"}
																style={{paddingLeft: searchKeyExists ? "0px" : "5px"}}
																onClick={(e) => this.onChangeSelected("sigortaList", e, ["pagesTransformation", "sigorta"])}>
																<Link to="/sigortaList">
																	<i className="fa fa-list"/>
																	<span className="sidebar-normal"
																		  style={{fontSize: "14px", fontWeight: "400"}}>E-Sigorta Listesi</span>
																</Link>
															</li>
														}
														{this.hasSidebarMenu("ednsm_sigorta_sendingReport") && this.hasContainsSearchKey("Gönderilmiş Raporlar") &&
															<li className={selected === "sigortaSentReportsList" ? 'active' : ''}
																id={"sigortaSentReportsList"}
																style={{
																	paddingLeft: searchKeyExists ? "0px" : "5px",
																	marginBottom: searchKeyExists ? "5px" : ""
																}}
																onClick={(e) => this.onSelectReport("sigortaSentReportsList", e, "sigorta", ["pagesTransformation", "sigorta"])}>
																<Link to="/sentReportsList/sigorta">
																	<i className="fa fa-area-chart"/>
																	<span className="sidebar-normal"
																		  style={{fontSize: "14px", fontWeight: "400"}}>
																	Gönderilmiş Raporlar
																		{searchKeyExists && <br/>}
																		{searchKeyExists ? " (e-Sigorta)" : ""}
																</span>
																</Link>
															</li>
														}
													</ul>
												</div>
											</li>
									}
									{ (this.isEFatura() || this.isEIrsaliye() || this.isEArsiv() || this.isESMM() || this.isEMM() || this.isEBelge()) && this.hasSidebarMenu("ednsm_raporlar") &&
										<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											{this.hasContainsSearchKey("not_submenu") &&
												<a data-toggle="collapse" href="#excelReports">
													<i className="fa fa-files-o" aria-hidden="true"/>
													<span className="sidebar-normal"> Raporlar<b
														className="caret"/></span>
												</a>
											}
											<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="excelReports">
												<ul className="nav">
													{this.hasSidebarMenu("ednsm_rapor_customize") && this.hasContainsSearchKey("Rapor Özelleştir") &&
														<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															id={"customizeExcel"}
															className={selected === "customizeExcel" ? 'active' : ''}
															onClick={(e) => this.onChangeSelected("customizeExcel", e,["pagesTransformation","excelReports"])}>
															<Link to="/customizeExcel">
																<i className="fa fa-files-o"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Rapor Özelleştir</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_rapor_generalReports") && this.hasContainsSearchKey("Genel Raporlar") &&
														<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															id={"excelRequest"}
															className={selected === "excelRequest" ? 'active' : ''}
															onClick={(e) => this.onChangeSelected("excelRequest", e, ["pagesTransformation","excelReports"])}>
															<Link to="/excelRequest">
																<i className="fa fa-files-o"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Genel Raporlar</span>
															</Link>
														</li>
													}
													{this.hasSidebarMenu("ednsm_rapor_rowReports") && this.hasContainsSearchKey("Satır Raporları") &&
														<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															id={"excelRequestWithLine"}
															className={selected === "excelRequestWithLine" ? 'active' : ''}
															onClick={(e) => this.onChangeSelected("excelRequestWithLine", e, ["pagesTransformation","excelReports"])}>
															<Link to="/excelRequestWithLine">
																<i className="fa fa-files-o"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>Satır Raporları</span>
															</Link>
														</li>
													}
													{this.isEczaciKart() && this.hasSidebarMenu("ednsm_rapor_generalReports") && this.hasContainsSearchKey("SGK Ciro Raporu") &&
														<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
															id={"excelRequestForSgkCiro"}
															className={selected === "excelRequestForSgkCiro" ? 'active' : ''}
															onClick={(e) => this.onChangeSelected("excelRequestForSgkCiro", e, ["pagesTransformation","excelReports"])}>
															<Link to="/excelRequestForSgkCiro">
																<i className="fa fa-files-o"/>
																<span className="sidebar-normal"
																	  style={{fontSize: "14px", fontWeight: "400"}}>SGK Ciro Raporu</span>
															</Link>
														</li>
													}
												</ul>
											</div>
										</li>
									}
								</ul>
								}
							</div>
						</li>
						}

						{(this.hasSidebarMenu("main_edefterchk") && this.isDefterChecker()) &&
						<li>
							{this.hasContainsSearchKey("not_submenu") &&
								<a data-toggle="collapse" href="#defterchecker">
									<i className="fa fa-book"/>
									<p>
										Defter Kontrol
										<b className="caret"/>
									</p>
								</a>
							}
							<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="defterchecker">
								<ul className="nav">
									{this.hasSidebarMenu("edefterchk_defterimportwizard") && this.hasContainsSearchKey("Defter Yükle") &&
									<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
										id={"defterchecker/defterimportwizard"}
										className={selected === "defterchecker/defterimportwizard" ? 'active' : ''}
										onClick={(e) => this.onChangeSelected("defterchecker/defterimportwizard", e,["defterchecker"])}>
										<Link to="/defterchecker/defterimportwizard">
											<i className="fa fa-plus-square"/>
											<p style={{fontSize: "14px", fontWeight: "400"}}>Defter Yükle</p>
										</Link>
									</li>
									}
								</ul>
							</div>
						</li>
						}

						{(((this.isEntegrator() || this.isDistributor()) && this.isAdminUser()) || this.props.currentUser.accountant) && this.hasSidebarMenu("portal_managament") &&
						<li>
							{this.hasContainsSearchKey("not_submenu") &&
								<a data-toggle="collapse" href="#manage">
									<i className="fa fa-cogs"/>
									<p>Portal Yönetimi<b className="caret"/></p>
								</a>
							}
							<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="manage">
								<ul className="nav">
									{this.hasSidebarMenu("customer_actions") && this.hasContainsSearchKey("Müşteri İşlemleri") &&
									<li className={selected === "customer" ? 'active' : ''}
										id={"customer"}
										onClick={(e) => this.onChangeSelected("customer", e,["manage"])}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
										<Link to="/customer">
											<i className="fa fa-address-card"/>
											<span className="sidebar-normal"
												  style={{fontSize: "14px", fontWeight: "400"}}>Müşteri İşlemleri</span>
										</Link>
									</li>
									}
									{this.props.currentUser.hasDistributorSealAuthority === true &&
										<li className={selected === "financeSealList" ? 'active' : ''}
											id={"financeSealList"}
											onClick={(e) => this.onChangeSelected("financeSealList", e, ["manage"])}
											style={{paddingLeft: searchKeyExists ? "0px" : "5px"}}>
											<Link to="/financeSealList">
												<i style={{fontSize: "12px"}} className="fa fa-stamp"/>
												<span className="sidebar-normal"
													  style={{
														  fontSize: "14px",
														  fontWeight: "400"
													  }}>Mali Mühür </span>
											</Link>
										</li>
									}
									{(this.props.currentUser.accountant || this.isEntegrator()) && ([EntegratorIdentifiers.KOLAYSOFT].includes(this.state.entegratorConf.identifier) ||
											[EntegratorIdentifiers.SMART].includes(this.state.entegratorConf.identifier) || [EntegratorIdentifiers.MBT].includes(this.state.entegratorConf.identifier))
										&& this.hasContainsSearchKey("Muhasebe Defter Bilgi") &&
										<li className={selected === "muhasebeDefter" ? 'active' : ''}
											id={"muhasebeDefter"}
											onClick={(e) => this.onChangeSelected("muhasebeDefter", e,["manage"])}
											style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											<Link to="/muhasebeDefter">
												<i className="fa fa-book"/>
												<span className="sidebar-normal"
													  style={{fontSize: "14px", fontWeight: "400"}}>Muhasebe Defter Bilgi </span>
											</Link>
										</li>
									}
									{!this.props.currentUser.accountant && this.hasSidebarMenu("all_users") && this.hasContainsSearchKey("Tüm Kullanıcılar") &&
									<li className={selected === "cUserList" ? 'active' : ''}
										id={"cUserList"}
										onClick={(e) => this.onChangeSelected("cUserList", e,["manage"])}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
										<Link to="/cUserList">
											<i className="fa fa-users"/>
											<span className="sidebar-normal"
												  style={{fontSize: "14px", fontWeight: "400"}}>Tüm Kullanıcılar</span>
										</Link>
									</li>}
									{(showCustomerAnnouncement() && this.isEntegrator() && this.isAdminUser() && (this.props.impersonateUserRoleId !== 3 && this.props.impersonateUserRoleId !== 4))
										&& this.hasSidebarMenu("ednsm_settings_announcementSettings") && this.hasContainsSearchKey("Duyuru Ayarları") &&
										<li className={selected === "announcementList" ? 'active' : ''}
											id={"announcementList"}
											onClick={(e) => this.onChangeSelected("announcementList", e,["manage"])}
											style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											<Link to="/announcementList">
												<i className="fa fa-bullhorn"/>
												<span className="sidebar-normal" style={{
													fontSize: "14px",
													fontWeight: "400"
												}}>Duyuru Ayarları</span>
											</Link>
										</li>
									}
									{(showCustomerAnnouncement() && this.isEntegrator() && this.isAdminUser() && (this.props.impersonateUserRoleId !== 3 && this.props.impersonateUserRoleId !== 4))
										&& this.hasSidebarMenu("ednsm_settings_surveySettings") && this.hasContainsSearchKey("Anket Ayarları") &&
										<li className={selected === "surveyList" ? 'active' : ''}
											id={"surveyList"}
											onClick={(e) => this.onChangeSelected("surveyList", e,["manage"])}
											style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											<Link to="/surveyList">
												<i className="fa fa-clipboard-list" />
												<span className="sidebar-normal" style={{
													fontSize: "14px",
													fontWeight: "400"
												}}>Anket Ayarları</span>
											</Link>
										</li>
									}
									{((this.isEntegrator() || this.isDistributor()) && this.isAdminUser() && (this.props.impersonateUserRoleId !== 3 && this.props.impersonateUserRoleId !== 4)) &&
										hasUserRight(UserRightsEnum.entegratorSettings.showDocumentStatus, this.props.currentUser) && this.hasSidebarMenu("document_status")
										&& this.hasContainsSearchKey("Belge Durumu") &&
										<li className={selected === "documentStatusInfo" ? 'active' : ''}
											id={"documentStatusInfo"}
											style={{
												paddingLeft: searchKeyExists ? "0px" : "5px",
												marginBottom: searchKeyExists ? "5px" : ""
											}}
											onClick={(e) => this.onChangeSelected("documentStatusInfo", e,["manage"])}>
											<Link to="/documentStatusInfo">
												<i className="fa fa-share"/>
												<span className="sidebar-normal"
													  style={{fontSize: "14px", fontWeight: "400"}}>
													Belge Durumu
													{searchKeyExists && <br/>}
													{searchKeyExists ? " (Portal Yönetimi)" : ""}
												</span>
											</Link>
										</li>
									}

									{!this.props.currentUser.accountant && this.hasSidebarMenu("credit_pool") && this.hasContainsSearchKey("Kredi Havuzu") &&
									<li className={selected === "creditPoolList" ? 'active' : ''}
										id={"creditPoolList"}
										onClick={(e) => this.onChangeSelected("creditPoolList", e,["manage"])}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
										<Link to="/creditPoolList">
											<i className="fa fa-server"/>
											<span className="sidebar-normal"
												  style={{fontSize: "14px", fontWeight: "400"}}>Kredi Havuzu</span>
										</Link>
									</li>}

									{
										(
											(
												(this.isEntegrator() || this.isDistributor()) &&
												(this.isAdminUser() || this.isTakimLideriUser()) &&
												showProgressPayment(this.props.currentUser.customerId)
											)
											||
											(
												this.isDistributor() &&
												(
													EntegratorIdentifiers.SMART === this.state.entegratorConf?.identifier
												) &&
												this.props.currentUser.workType === 1
											)
										)
										&& this.hasSidebarMenu("ednsm_settings_progressPayment")
										&& this.hasContainsSearchKey("Hakediş") &&
										<li className={selected === "progresspayment" ? 'active' : ''}
											id={"progresspayment"}
											onClick={(e) => this.onChangeSelected("progresspayment", e,["manage"])}
											style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											<Link to="/progresspayment">
												<i className="fa fa-address-card"/>
												<span className="sidebar-normal"
													  style={{fontSize: "14px", fontWeight: "400"}}>Hakediş</span>
											</Link>
										</li>
									}
									{!this.props.currentUser.accountant && this.hasSidebarMenu("credit_report") && this.hasContainsSearchKey("Kredi Raporu") &&
									<li className={selected === "creditList" ? 'active' : ''}
										id={"creditList"}
										onClick={(e) => this.onChangeSelected("creditList", e,["manage"])}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
										<Link to="/creditList">
											<i className="fa fa-server"/>
											<span className="sidebar-normal"
												  style={{fontSize: "14px", fontWeight: "400"}}>Kredi Raporu</span>
										</Link>
									</li>}

									{!this.props.currentUser.accountant && this.hasSidebarMenu("request_report") && this.hasContainsSearchKey("İstek/Talep Raporu") &&
									<li className={selected === "requestMessageList" ? 'active' : ''}
										id={"requestMessageList"}
										onClick={(e) => this.onChangeSelected("requestMessageList", e,["manage"])}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
										<Link to="/requestMessageList">
											<i className="fa fa-server"/>
											<span className="sidebar-normal" style={{
												fontSize: "14px",
												fontWeight: "400"
											}}>İstek/Talep Raporu</span>
										</Link>
									</li>}
									{(VirtualHost.conf.resourcePrefix === "kolaysoft" && this.isEntegrator() && this.hasSidebarMenu("ednsm_settings_sgkRanList")) && this.hasContainsSearchKey("Randevu Listesi") &&
									<li className={selected === "sgkAppointmentList" ? 'active' : ''}
										id={"sgkAppointmentList"}
										onClick={(e) => this.onChangeSelected("sgkAppointmentList", e,["manage"])}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
										<Link to="/sgkAppointmentList">
											<i className="fa fa-server"/>
											<span className="sidebar-normal"
												  style={{fontSize: "14px", fontWeight: "400"}}>Randevu Listesi</span>
										</Link>
									</li>
									}
									{this.isEntegrator() && this.isAdminUser() && VirtualHost.conf.resourcePrefix === "kolaysoft" && this.hasSidebarMenu("ednsm_settings_integratorDemandTracking")
										&& this.hasContainsSearchKey("Entegratör Talep Takibi") &&
										<li className={selected === "customerRequestList" ? 'active' : ''}
											id={"customerRequestList"}
											onClick={(e) => this.onChangeSelected("customerRequestList", e,["manage"])}
											style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											<Link to="/customerRequestList">
												<i className="fa fa-server"/>
												<span className="sidebar-normal"
													  style={{fontSize: "14px", fontWeight: "400"}}>Entegratör Talep Takibi</span>
											</Link>
										</li>
									}
									{this.isEntegrator() && this.isAdminUser() && VirtualHost.conf.resourcePrefix === "kolaysoft" &&  this.hasSidebarMenu("ednsm_settings_releaseNotes")
										&& this.hasContainsSearchKey("Sürüm Notları") &&
									<li className={selected === "versionTrack" ? 'active' : ''}
										id={"versionTrack"}
										onClick={(e) => this.onChangeSelected("versionTrack", e,["manage"])}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
										<Link to="/versionTrack">
											<i className="fa fa-server"/>
											<span className="sidebar-normal"
												  style={{fontSize: "14px", fontWeight: "400"}}>Sürüm Notları</span>
										</Link>
									</li>
									}
									{this.isEntegrator() && this.isAdminUser() && VirtualHost.conf.resourcePrefix === "kolaysoft" &&  this.hasSidebarMenu("ednsm_settings_versionOperations")
										&& this.hasContainsSearchKey("Versiyon İşlemleri") &&
										<li className={selected === "versionTrackList" ? 'active' : ''}
											id={"versionTrackList"}
											onClick={(e) => this.onChangeSelected("versionTrackList", e,["manage"])}
											style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
											<Link to="/versionTrackList">
												<i className="fa fa-server"/>
												<span className="sidebar-normal" style={{
													fontSize: "14px",
													fontWeight: "400"
												}}>Versiyon İşlemleri</span>
											</Link>
										</li>
									}
									{(VirtualHost.conf.resourcePrefix === "kolaysoft" && this.isEntegrator() && this.isAdminUser()) && this.hasSidebarMenu("ednsm_settings_accountantList")
										&& this.hasContainsSearchKey("Muhasebeci Listesi") &&
									<li className={selected === "smmmUserInformation" ? 'active' : ''}
										id={"smmmUserInformation"}
										onClick={(e) => this.onChangeSelected("smmmUserInformation", e,["manage"])}
										style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
										<Link to="/smmmUsers">
											<i className="fa fa-address-card"/>
											<span className="sidebar-normal" style={{
												fontSize: "14px",
												fontWeight: "400"
											}}>Muhasebeci Listesi</span>
										</Link>
									</li>
									}
									{(this.state.entegratorConf && EntegratorIdentifiers.KOLAYSOFT === this.state.entegratorConf.identifier && this.isEntegrator() && this.isAdminUser()) && this.hasSidebarMenu("ednsm_settings_eczaciposList")
										&& this.hasContainsSearchKey("EczacıPos Seminer Listesi") &&
										<li className={selected === "seminarList" ? 'active' : ''}
											id={"seminarList"}
										onClick={(e) => this.onChangeSelected("seminarList", e,["manage"])}
											style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
										<Link to="/seminarList">
											<i className="fa fa-server"/>
											<span className="sidebar-normal"
												  style={{fontSize: "14px", fontWeight: "400"}}>EczacıPos Seminer Listesi</span>
										</Link>
									</li>
									}
									{(this.state.entegratorConf && EntegratorIdentifiers.KOLAYSOFT === this.state.entegratorConf.identifier && this.isEntegrator() && this.isAdminUser()) && this.hasSidebarMenu("ednsm_settings_customerCommentList")
										&& this.hasContainsSearchKey("Müşteri Yorumu Listesi") &&
										<li className={selected === "customerCommentList" ? 'active' : ''}
											id={"customerCommentList"}
											style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
											onClick={(e) => this.onChangeSelected("customerCommentList", e,["manage"])}>
											<Link to="/customerCommentList">
												<i className="fa fa-server"/>
												<span className="sidebar-normal"
													  style={{fontSize: "14px", fontWeight: "400"}}>Müşteri Yorumu Listesi</span>
											</Link>
										</li>
									}
									{((this.isEntegrator() && ["111111444", "okan.koylu"].includes(this.props.currentUser.username)) ||
											(this.props.currentUser && ["1910024001", "4810032523"].includes( this.props.currentUser.vknTckn) && this.isAdminUser()))
										&& this.hasContainsSearchKey("Alım Listesi") &&
										<li className={selected === "chemistWarehousePurchaseList" ? 'active' : ''}
											id={"chemistWarehousePurchaseList"}
										 onClick={(e) => this.onChangeSelected("chemistWarehousePurchaseList", e,["manage"])}
											style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
										<Link to="/chemistWarehousePurchaseList">
											<i className="fa fa-address-card"/>
											<span className="sidebar-normal"
												  style={{fontSize: "14px", fontWeight: "400"}}>Alım Listesi</span>
										</Link>
									</li>}
								</ul>
							</div>
						</li>
						}
					</ul>}
					{this.props.currentUser.recordId === 118651 &&
						<ul className="nav">
							<li className={selected === "timeline" ? 'active' : ''}
								onClick={(e) => this.onChangeSelected("timeline", e)}
								style={{"paddingLeft": "10px"}}>
								<Link to="/timeline">
									<i className="fa fa-clock-o"/>
									<p>Güncelleme Ayarları</p>
								</Link>
							</li>
						</ul>
					}
					{this.props.currentUser && this.props.currentUser.roleId &&
						(this.props.currentUser.roleId === 5 ||
							((this.state.entegratorConf &&
									(EntegratorIdentifiers.KOLAYSOFT !== this.state.entegratorConf.identifier &&
										EntegratorIdentifiers.SMART !== this.state.entegratorConf.identifier &&
										EntegratorIdentifiers.MBT !== this.state.entegratorConf.identifier)) &&
								this.props.currentUser && (this.props.currentUser.roleId === 3)) ||
							((this.state.entegratorConf &&
									(EntegratorIdentifiers.KOLAYSOFT !== this.state.entegratorConf.identifier &&
										EntegratorIdentifiers.SMART !== this.state.entegratorConf.identifier &&
										EntegratorIdentifiers.MBT !== this.state.entegratorConf.identifier)) &&
								this.props.currentUser && (this.props.currentUser.roleId === 4))) &&
						<ul className="nav">
							{this.props.currentUser.roleId === 3 && this.hasSidebarMenu("ednsm_queryEnvelope") &&
								this.hasContainsSearchKey("Zarf Sorgulama") &&
								(this.isEntegrator() || this.isDistributor()) &&
								<li style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
									<a onClick={this.props.queryEnvelopeListener}>
										<i className="fa fa-search"/>
										<p style={{fontSize: "14px", fontWeight: "400"}}>{"Zarf Sorgulama"}</p>
									</a>
								</li>
							}
							{this.props.currentUser.roleId === 3 && this.hasContainsSearchKey("GİB Kayıtlı Kullanıcılar") &&
								<li className={selected === "gibusersI" ? 'active' : ''}
									id={"gibusersI"}
									style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
									onClick={(e) => this.onChangeSelected("gibusersI", e)}>
									<Link to="/gibusersI">
										<i className="fa fa-users" aria-hidden="true"/>
										<p style={{fontSize: "14px", fontWeight: "400"}}>GİB Kayıtlı Kullanıcılar</p>
									</Link>
								</li>
							}
							{this.hasSidebarMenu("portal_managament") &&
								<li>
									{this.hasContainsSearchKey("not_submenu") &&
										<a data-toggle="collapse" href="#manage">
											<i className="fa fa-cogs"/>
											<p>Portal Yönetimi<b className="caret"/></p>
										</a>
									}
									<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="manage">
										<ul className="nav">
											{this.hasSidebarMenu("customer_actions") && this.hasContainsSearchKey("Müşteri İşlemleri") &&
												<li className={selected === "customer" ? 'active' : ''}
													id={"customer"}
													onClick={(e) => this.onChangeSelected("customer", e,["manage"])}
													style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
													<Link to="/customer">
														<i className="fa fa-address-card"/>
														<span className="sidebar-normal"
															  style={{fontSize: "14px", fontWeight: "400"}}>Müşteri İşlemleri</span>
													</Link>
												</li>
											}
											{this.hasSidebarMenu("all_users") && this.hasContainsSearchKey("Tüm Kullanıcılar") &&
												<li className={selected === "cUserList" ? 'active' : ''}
													id={"cUserList"}
													onClick={(e) => this.onChangeSelected("cUserList", e,["manage"])}
													style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
													<Link to="/cUserList">
														<i className="fa fa-users"/>
														<span className="sidebar-normal"
															  style={{fontSize: "14px", fontWeight: "400"}}>Tüm Kullanıcılar</span>
													</Link>
												</li>
											}
											{(this.props.currentUser.roleId === 5 || this.props.currentUser.roleId === 4) && hasUserRight(UserRightsEnum.entegratorSettings.showDocumentStatus, this.props.currentUser)
												&& this.hasSidebarMenu("document_status") && this.hasContainsSearchKey("Belge Durumu") &&
												<li className={selected === "documentStatusInfo" ? 'active' : ''}
													id={"documentStatusInfo"}
													style={{
														paddingLeft: searchKeyExists ? "0px" : "5px",
														marginBottom: searchKeyExists ? "5px" : ""
													}}
													onClick={(e) => this.onChangeSelected("documentStatusInfo", e,["manage"])}>
													<Link to="/documentStatusInfo">
														<i className="fa fa-share"/>
														<span className="sidebar-normal" style={{
															fontSize: "14px",
															fontWeight: "400"
														}}>
															Belge Durumu
															{searchKeyExists && <br/>}
															{searchKeyExists ? " (Portal Yönetimi)" : ""}
														</span>
													</Link>
												</li>
											}
											{this.hasSidebarMenu("request_report") && this.hasContainsSearchKey("İstek/Talep Raporu") &&
												<li className={selected === "requestMessageList" ? 'active' : ''}
													id={"requestMessageList"}
													onClick={(e) => this.onChangeSelected("requestMessageList", e,["manage"])}
													style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
													<Link to="/requestMessageList">
														<i className="fa fa-server"/>
														<span className="sidebar-normal"
															  style={{fontSize: "14px", fontWeight: "400"}}>İstek/Talep Raporu</span>
													</Link>
												</li>
											}
											{this.hasContainsSearchKey("Müşteri İstek/Talep Takibi") &&
												<li className={selected === "customerRequestList" ? 'active' : ''}
													id={"customerRequestList"}
													onClick={(e) => this.onChangeSelected("customerRequestList", e,["manage"])}
													style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
													<Link to="/customerRequestList">
														<i className="fa fa-server"/>
														<span
															className="sidebar-normal"
															style={{fontSize: "14px", fontWeight: "400"}}>Müşteri İstek/Talep Takibi</span>
													</Link>
												</li>
											}
											{this.props.currentUser.roleId !== 3 && this.hasContainsSearchKey("GİB Kayıtlı Kullanıcılar") &&
												<li className={selected === "gibusersI" ? 'active' : ''}
													id={"gibusersI"}
													style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}
													onClick={(e) => this.onChangeSelected("gibusersI", e,["manage"])}>
													<Link to="/gibusersI">
														<i className="fa fa-users" aria-hidden="true"/>
														<span className="sidebar-normal"
															  style={{fontSize: "14px", fontWeight: "400"}}>GİB Kayıtlı Kullanıcılar</span>
													</Link>
												</li>
											}
											{(this.isEntegrator() && VirtualHost.conf.resourcePrefix === "kolaysoft") && this.hasSidebarMenu("ednsm_settings_accountantList") && this.hasContainsSearchKey("Muhasebeci Listesi") &&
												<li className={selected === "smmmUserInformation" ? 'active' : ''}
													id={"smmmUserInformation"}
													onClick={(e) => this.onChangeSelected("smmmUserInformation", e,["manage"])}
													style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
													<Link to="/smmmUsers">
														<i className="fa fa-address-card"/>
														<span className="sidebar-normal"
															  style={{fontSize: "14px", fontWeight: "400"}}>Muhasebeci Listesi</span>
													</Link>
												</li>
											}
										</ul>
									</div>
								</li>
							}
						</ul>}
					{((this.state.entegratorConf &&
								(EntegratorIdentifiers.KOLAYSOFT === this.state.entegratorConf.identifier ||
									EntegratorIdentifiers.SMART === this.state.entegratorConf.identifier ||
									EntegratorIdentifiers.MBT === this.state.entegratorConf.identifier)) &&
							this.props.currentUser && (this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4)) &&
						<ul className="nav">
							{this.props.currentUser.roleId === 3 &&
								<li className={selected === "gibusersI" ? 'active' : ''}
									style={{"paddingLeft": "5px"}}
									onClick={(e) => this.onChangeSelected("gibusersI", e)}>
									<Link to="/gibusersI">
										<i className="fa fa-users" aria-hidden="true"/>
										<p>GİB Kayıtlı Kullanıcılar</p>
									</Link>
								</li>
							}
							{this.hasSidebarMenu("portal_managament") &&
								<li>
									{this.hasContainsSearchKey("not_submenu") &&
										<a data-toggle="collapse" href="#manage">
											<i className="fa fa-cogs"/>
											<p>Portal Yönetimi<b className="caret"/></p>
										</a>
									}
									<div className={`collapse ${searchKeyExists ? 'show' : ''}`} id="manage">
										<ul className="nav">
											{this.hasSidebarMenu("customer_actions") && this.hasContainsSearchKey("Müşteri İşlemleri") &&
												<li className={selected === "customer" ? 'active' : ''}
													id={"customer"}
													onClick={(e) => this.onChangeSelected("customer", e,["manage"])}
													style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
													<Link to="/customer">
														<i className="fa fa-address-card"/>
														<span className="sidebar-normal"
															  style={{fontSize: "14px", fontWeight: "400"}}>Müşteri İşlemleri</span>
													</Link>
												</li>
											}

											{this.hasSidebarMenu("all_users") && this.hasContainsSearchKey("Tüm Kullanıcılar") &&
												<li className={selected === "cUserList" ? 'active' : ''}
													id={"cUserList"}
													onClick={(e) => this.onChangeSelected("cUserList", e,["manage"])}
													style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
													<Link to="/cUserList">
														<i className="fa fa-users"/>
														<span className="sidebar-normal"
															  style={{fontSize: "14px", fontWeight: "400"}}>Tüm Kullanıcılar</span>
													</Link>
												</li>
											}

											{hasUserRight(UserRightsEnum.entegratorSettings.showDocumentStatus, this.props.currentUser) && this.hasSidebarMenu("document_status") && this.hasContainsSearchKey("Belge Durumu") &&
												<li className={selected === "documentStatusInfo" ? 'active' : ''}
													id={"documentStatusInfo"}
													style={{
														paddingLeft: searchKeyExists ? "0px" : "5px",
														marginBottom: searchKeyExists ? "5px" : ""
													}}
													onClick={(e) => this.onChangeSelected("documentStatusInfo", e,["manage"])}>
													<Link to="/documentStatusInfo">
														<i className="fa fa-share"/>
														<span className="sidebar-normal" style={{
															fontSize: "14px",
															fontWeight: "400"
														}}>
															Belge Durumu
															{searchKeyExists && <br/>}
															{searchKeyExists ? " (Portal Yönetimi)" : ""}
														</span>
													</Link>
												</li>
											}

											{this.hasSidebarMenu("request_report") && this.hasContainsSearchKey("İstek/Talep Raporu") &&
												<li className={selected === "requestMessageList" ? 'active' : ''}
													id={"requestMessageList"}
													onClick={(e) => this.onChangeSelected("requestMessageList", e,["manage"])}
													style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
													<Link to="/requestMessageList">
														<i className="fa fa-server"/>
														<span className="sidebar-normal"
															  style={{fontSize: "14px", fontWeight: "400"}}>İstek/Talep Raporu</span>
													</Link>
												</li>
											}

											{(VirtualHost.conf.resourcePrefix === "kolaysoft" && this.isEntegrator() && this.hasSidebarMenu("ednsm_settings_sgkRanList")) && this.hasContainsSearchKey("Randevu Listesi") &&
												<li className={selected === "sgkAppointmentList" ? 'active' : ''}
													id={"sgkAppointmentList"}
													onClick={(e) => this.onChangeSelected("sgkAppointmentList", e,["manage"])}
													style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
													<Link to="/sgkAppointmentList">
														<i className="fa fa-server"/>
														<span className="sidebar-normal"
															  style={{fontSize: "14px", fontWeight: "400"}}>Randevu Listesi</span>
													</Link>
												</li>
											}

											{false && this.hasContainsSearchKey("Sürüm Notları") &&
												<li className={selected === "versionTrack" ? 'active' : ''}
													id={"versionTrack"}
													onClick={(e) => this.onChangeSelected("versionTrack", e,["manage"])}
													style={{ paddingLeft: searchKeyExists ? "0px" : "5px" }}>
													<Link to="/versionTrack">
														<i className="fa fa-server"/>
														<span className="sidebar-normal"
															  style={{fontSize: "14px", fontWeight: "400"}}>Sürüm Notları</span>
													</Link>
												</li>
											}
										</ul>
									</div>
								</li>
							}
						</ul>}
				</div>
			</div>
		);
	}
}

export default Sidebar;